<div class="responsive-card d-flex flex-column">
  <span class="upload-title">{{ cardTitle }}</span>
  <div class="upload-description">
    {{ description }}
  </div>
  <app-tertiary-button
    (buttonClicked)="downloadTemplate()"
    [leftIconSrc]="'assets/icons/blue/Download.svg'"
    [size]="BaseButtonSizeEnum.lg"
    [colour]="BaseButtonColourEnum.Blue"
    i18n>
    Download Template
  </app-tertiary-button>
  <form [style.margin-top.rem]="1.5" [style.margin-bottom.rem]="2" [formGroup]="formGroup" (ngSubmit)="submitForm()">
    <app-file-upload-field
      formControlName="file"
      [control]="formGroup.controls.file"
      [inputName]="'file'"
      [accept]="['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/dat']"
      [interceptPreviewClick]="true"
      [maxFileSizeInMb]="3"
      [interceptRemoveClick]="true"
      (previewClicked)="openPreviewModal($event)"
      (removeClicked)="onRemoveFile()">
      <ng-container input-copy>
        <img height="24" src="assets/icons/blue/UploadFile.svg" alt="Upload File" i18n-alt />
        <app-file-uploader-text
          instructionText="Upload a file or drag and drop a .csv, .dat, or .xlsx"
          i18n-instructionText
          descriptionText="Up to 3 MB"
          i18n-descriptionText />
      </ng-container>
    </app-file-upload-field>
  </form>
  <div class="d-flex justify-content-between mt-2">
    <app-secondary-button
      (buttonClicked)="skipFileUpload()"
      [size]="BaseButtonSizeEnum.sm"
      [colour]="BaseButtonColourEnum.Blue"
      i18n>
      Skip Template
    </app-secondary-button>
    <app-primary-button
      *ngIf="formGroup.controls.file?.value?.length"
      (buttonClicked)="primaryClicked()"
      [size]="BaseButtonSizeEnum.sm"
      [colour]="BaseButtonColourEnum.Blue">
      {{ primaryText$ | async }}
    </app-primary-button>
  </div>
</div>
